const gouvernance = {
  init() {
    if (document.querySelector(".block-gouvernance")) {
      this.displayPopin();
    }
  },
  displayPopin() {
    const $cards = document.querySelectorAll(".block-gouvernance ul li");
    $cards.forEach((card, indexOfCard) => {
      let willBeDisplayed = true;
      card.querySelector("button").addEventListener("click", e => {
        if (willBeDisplayed) {
          $cards.forEach(card => {
            card.querySelector(".content").classList.remove("active");
            card.querySelector("button span").classList.remove("active");
            card.style.marginBottom = "0px";
          });
          const $content = card.querySelector(".content");
          $content.classList.add("active");
          e.target.querySelector("span").classList.add("active");

          const pH = $content.getBoundingClientRect().height;
          const cW = card.getBoundingClientRect().width;

          let colsEntity;
          if (window.innerWidth >= 768)
            colsEntity = { cols: 4, lastCardInLineIndex: 3, setBaseIndex: 0 };
          else
            colsEntity = { cols: 2, lastCardInLineIndex: 1, setBaseIndex: 1 };
          for (
            let indexOfLine = 0;
            indexOfLine < $cards.length / colsEntity.cols;
            indexOfLine++
          ) {
            const indexOfCardInLine = (indexOfCard + 1) / colsEntity.cols;
            // = 0.25, 0.5, 0.75, 1
            const IndexOfLineOfClickedCard = colsEntity.cols * indexOfLine;
            // desktop => = 4 * 0, 4 * 1, 4 * 2; mobile => = 2 * 0, 2 * 1, 2 * 2;
            if (
              indexOfCardInLine > indexOfLine &&
              indexOfCardInLine <= indexOfLine + 1
            ) {
              for (
                let i = IndexOfLineOfClickedCard;
                i < IndexOfLineOfClickedCard + colsEntity.cols;
                i++
              ) {
                $cards[i]
                  ? ($cards[i].style.marginBottom = `${pH + 100}px`)
                  : null;
                $content.style.left = `${-(indexOfCardInLine % 1 !== 0
                  ? (indexOfCardInLine % 1) / 0.25 - 1 - colsEntity.setBaseIndex
                  : colsEntity.lastCardInLineIndex) * cW}px`;
                // 0.25 % 1 = 0.25, 1.25 % 1 = 0.25, 2.25 % 1 = 0.25 // 0.50 % 1 = 0.25, 1.50 % 1 = 0.25, 2.50 % 1 = 0.25
                // 0 / 0.25 = 0, 0.25 / 0.25 = 1, 0.5 / 0.25 = 2, 0.75 / 0.25 = 3,
                // - 1 to set array index
                // else, desk = 3 // mob = 1
              }
            }
          }
          willBeDisplayed = false;
          
          if (window.matchMedia('(max-width: 767px)').matches) {
            setTimeout(() => {
              let scroll = card.offsetTop + card.getBoundingClientRect().height;
              window.scrollTo(0, scroll - 80);
            }, 250);
          }
        } else {
          $cards.forEach(card => {
            card.querySelector(".content").classList.remove("active");
            card.querySelector("button span").classList.remove("active");
            card.style.marginBottom = "0px";
          });
          willBeDisplayed = true;
        }
      });
    });
  }
};

export default gouvernance;
